import * as React from "react";

import { cn } from "@/lib/utils";
import { cva, VariantProps } from "class-variance-authority";

const inputVariants = cva("h-14 w-full rounded border border-gray-400 bg-white p-4 text-base text-gray-1000 placeholder:text-gray-500", {
  variants: {
    border: {
      normal: "focus:border-blue-600 focus:outline-none",
      warn: "border-yellow-700 focus:outline-none",
      error: "border-red-700 focus:outline-none",
    },
  },
  defaultVariants: {
    border: "normal",
  },
});

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & VariantProps<typeof inputVariants>;

const Input = React.forwardRef<HTMLInputElement, InputProps>(({ className, border, ...props }, ref) => {
  return <input className={cn(inputVariants({ border, className }))} ref={ref} {...props} />;
});
Input.displayName = "Input";

export { Input };
